import React, { useEffect, useState } from 'react'
import ReactModal from 'react-modal'
import CloseBtn from '../../buttons/CloseBtn'
import { Form } from 'react-bootstrap'
import RequieredInputs from '../../common/RequiredInputs'
import { useDispatch, useSelector } from 'react-redux'
import { eventosActions } from '../../../actions/eventosActions'
import _ from 'lodash'
import './tasks-modal.scss'
import DateField from '../../fields/DateField/DateField'

const TasksModal = ({
  modalIsOpen,
  closeModal,
  inputs,
  handleChange,
  handleSubmit,
  validateForm,
  textBtn,
  phases = [],
  contacts = [],
  events = [],
  businessunits = [],
  hospitals = [],
  specialties = [],
  isEdit = false,
  disableEventField = false,
  isViewMode = false, // Nuevo prop para modo de solo lectura
}) => {
  const dispatch = useDispatch()
  const getAllEventos = () => dispatch(eventosActions.getAllEventos())

  const [eventos, setEventos] = useState([])
  const [localBusinessUnits, setLocalBusinessUnits] = useState([])

  const userProfile = useSelector((state) => state.userProfile)
  

  // Sincronizar unidades de negocio locales con inputs cuando cambien
  useEffect(() => {
    setLocalBusinessUnits(inputs.id_NegocioUnidades || [])
  }, [inputs.id_NegocioUnidades])

  useEffect(() => {

    try {

   
      if(inputs.id_Contacto) {
        // TODO:
        const selectedContact = contacts.find(
          (contact) => contact.id_Contacto === parseInt(inputs.id_Contacto)
        )

        if (selectedContact && selectedContact.id_Hospitales && selectedContact.id_Hospitales.length > 0) {

          handleChange([
            {
              target: {
                name: 'hospitales',
                value: sortedData.hospitals.filter(h => h.id_Hospital === selectedContact.id_Hospitales[0])[0].nombre
              }
            },
            {
              target: {
                name: 'especialidades',
                value: sortedData.specialties.filter(e => e.id_TipoEspecialidad === selectedContact.id_Especialidades[0])[0].nombre
              },
            }
          ]);

        }
      } else {
          handleChange([
            {
              target: {
                name: 'hospitales',
                value: ''
              }
            },
            {
              target: {
                name: 'especialidades',
                value: null
              },
            }
          ]);
        }
    } catch (err) {
      console.error("TasksModal", 'Error setting hospital/especialidad from contact:', err);
    }
  }, [inputs.id_Contacto])

  // Efecto para sincronizar unidades de negocio cuando hay un evento preseleccionado
  useEffect(() => {
    if (inputs.id_Evento && eventos.length > 0) {
      const selectedEvento = eventos.find(
        (evento) => evento.id_Evento === parseInt(inputs.id_Evento),
      )
      if (selectedEvento && selectedEvento.id_NegocioUnidades) {
        const unidades = Array.isArray(selectedEvento.id_NegocioUnidades)
          ? selectedEvento.id_NegocioUnidades
          : [selectedEvento.id_NegocioUnidades]

          // Solo se añadirán las que el usuario tenga permiso
          const unidadesFiltradas = unidades.filter(unitId =>
            userProfile.id_NegocioUnidades.includes(unitId)
          )

        // Actualizar siempre las unidades de negocio basadas en el evento seleccionado
        // Esto asegura consistencia entre crear y editar
        setLocalBusinessUnits(unidadesFiltradas)
      }
    } else if (!inputs.id_Evento) {
      // Si no hay evento seleccionado, usar las unidades de negocio directas de inputs
      setLocalBusinessUnits(inputs.id_NegocioUnidades || [])
    }
  }, [inputs.id_Evento, eventos, inputs.id_NegocioUnidades])

  // Función para validar y formatear fechas
  const handleDateChange = (event) => {
    // El DateField ya envía el evento con el formato correcto (YYYY-MM-DD)
    const { value } = event.target
    if (!value || /^\d{4}-\d{2}-\d{2}$/.test(value)) {
      handleChange(event)
    }
  }

  // Función para manejar cambio de evento relacionado y actualizar unidades de negocio
  const handleEventoRelacionadoChange = (event) => {
    const { value } = event.target

    // Actualizar el campo del evento
    handleChange(event)

    // Buscar y actualizar unidades de negocio
    if (value) {
      const selectedEvento = eventos.find(
        (evento) => evento.id_Evento === parseInt(value),
      )
      const unidades =
        selectedEvento && selectedEvento.id_NegocioUnidades
          ? selectedEvento.id_NegocioUnidades
          : []

      setLocalBusinessUnits(Array.isArray(unidades) ? unidades : [unidades])

      // También actualizar el estado del formulario para la validación
      const syntheticEvent = {
        target: {
          name: 'id_NegocioUnidades',
          value: Array.isArray(unidades) ? unidades : [unidades],
        },
      }
      handleChange(syntheticEvent)
    } else {
      setLocalBusinessUnits([])
      // Limpiar las unidades de negocio del formulario
      const syntheticEvent = {
        target: {
          name: 'id_NegocioUnidades',
          value: [],
        },
      }
      handleChange(syntheticEvent)
    }
  }

  useEffect(() => {
    if (modalIsOpen) {
      retrieveEventos()
    }
  }, [modalIsOpen])

  const retrieveEventos = async () => {
    try {
      const response = await getAllEventos()
      setEventos(response && response.payload ? response.payload : [])
    } catch (error) {
      console.error('Error loading eventos:', error)
      setEventos([])
    }
  }

  // Estilos para unidades de negocio
  const unitContainerStyle = {
    padding: '10px',
    backgroundColor: 'transparent',
    border: '1px solid #00a499',
    borderRadius: '8px',
    minHeight: '40px',
    display: 'flex',
    flexWrap: 'wrap',
    gap: '6px',
    alignItems: 'center',
  }

  const unitBadgeStyle = {
    backgroundColor: '#00a499',
    color: '#1a202c',
    padding: '4px 10px',
    borderRadius: '12px',
    fontSize: '12px',
    fontWeight: '500',
    display: 'inline-block',
    whiteSpace: 'nowrap',
  }

  const emptyStateStyle = {
    padding: '12px',
    backgroundColor: 'transparent',
    border: '1px solid #00a499',
    borderRadius: '8px',
    color: '#a0aec0',
    textAlign: 'center',
    fontStyle: 'italic',
    fontSize: '14px',
  }

  // Estilos personalizados para el modal
  const customStyles = {
    overlay: {
      zIndex: 4,
    },
    content: {
      width: '90%',
      maxHeight: '90vh',
      padding: '25px',
      overflow: 'auto',
    },
  }

  // Datos ordenados
  const sortedData = {
    events: _.orderBy(events, ['nombre'], ['asc']),
    phases: _.orderBy(phases, ['id_TipoFase'], ['asc']),
    contacts: _.orderBy(contacts, ['nombre'], ['asc']),
    businessUnits: _.orderBy(businessunits, ['nombre'], ['asc']),
    hospitals: _.orderBy(hospitals, ['nombre'], ['asc']),
    specialties: _.orderBy(specialties, ['nombre'], ['asc']),
  }
  return (
    <div className='tasks-modal'>
      <ReactModal
        isOpen={modalIsOpen}
        onRequestClose={closeModal}
        contentLabel={isEdit ? 'Editar lead' : 'Crear nuevo lead'}
        className='custom-modal'
        style={customStyles}
      >
        <span className='custom-modal__close close-btn' onClick={closeModal}>
          <CloseBtn />
        </span>
        <h4 className='custom-modal__title'>
          {isViewMode
            ? 'Ver lead'
            : isEdit
            ? 'Editar lead'
            : 'Crear nuevo lead'}
        </h4>
        <Form onSubmit={handleSubmit} className='modal__form'>
          <div className='modal-form-container'>

            {/* Tipo de Asunto */}
            <div className='modal-form-field'>

              <Form.Group size='lg'>
                <Form.Label className='form__labels'>Tipo de Asunto</Form.Label>
                <Form.Control
                  as='select'
                  className='user-input form__input'
                  name='id_TipoAsunto'
                  value={inputs.id_TipoAsunto || ''}
                  onChange={handleChange}
                  disabled={isViewMode}
                  readOnly={isViewMode}
                >
                  <option value=''>Seleccionar tipo de asunto</option>
                  {sortedData.events.map((event) => (
                    <option
                      key={event.id_TipoAsunto}
                      value={event.id_TipoAsunto}
                    >
                      {event.nombre}
                    </option>
                  ))}
                </Form.Control>
              </Form.Group>
            </div>

            {/* Asunto */}
            <div className='modal-form-field'>
              <Form.Group size='lg'>
                <Form.Label className='form__labels'>
                  Asunto <RequieredInputs />
                </Form.Label>
                <Form.Control
                  type='text'
                  className='user-input form__input'
                  name='asunto'
                  value={inputs.asunto || ''}
                  onChange={handleChange}
                  placeholder='Asunto del lead'
                  readOnly={isViewMode}
                />
              </Form.Group>
            </div>
          </div>

          <div className='modal-form-container'>

            {/* Fase */}
            <div className='modal-form-field modal-form-field--small'>
              <Form.Group size='lg'>
                <Form.Label className='form__labels'>
                  Fase <RequieredInputs />
                </Form.Label>
                <Form.Control
                  as='select'
                  className='user-input form__input'
                  name='id_TipoFase'
                  value={inputs.id_TipoFase || ''}
                  onChange={handleChange}
                  disabled={isViewMode}
                  readOnly={isViewMode}
                >
                  <option value=''>Elegir fase</option>
                  {sortedData.phases.map((phase) => (
                    <option key={phase.id_TipoFase} value={phase.id_TipoFase}>
                      {phase.nombre}
                    </option>
                  ))}
                </Form.Control>
              </Form.Group>
            </div>

            {/* Contacto */}
            <div className='modal-form-field modal-form-field--small'>
              <Form.Group size='lg'>
                <Form.Label className='form__labels'>
                  Contacto <RequieredInputs />
                </Form.Label>
                <Form.Control
                  as='select'
                  className='user-input form__input'
                  name='id_Contacto'
                  value={inputs.id_Contacto || ''}
                  onChange={handleChange}
                  disabled={isViewMode}
                  readOnly={isViewMode}
                >
                  <option value=''>Elegir contacto</option>
                  {sortedData.contacts.map((contact) => (
                    <option
                      key={contact.id_Contacto}
                      value={contact.id_Contacto}
                    >
                      {contact.nombre}
                    </option>
                  ))}
                </Form.Control>
              </Form.Group>
            </div>

            {/* Fecha */}
            <div className='modal-form-field modal-form-field--small'>
              <Form.Group size='lg'>
                <Form.Label className='form__labels'>
                  Fecha <RequieredInputs />
                </Form.Label>
                <DateField
                  name='fecha'
                  value={inputs.fecha || ''}
                  onChange={handleDateChange}
                  required={true}
                  maxDate={new Date(9999, 11, 31)}
                  disabled={isViewMode}
                />
              </Form.Group>
            </div>

            {/* Checkbox */}
            <div className='modal-form-field modal-form-field--small'>
              <Form.Group size='lg'>
                <Form.Check
                  type='checkbox'
                  name='isVerCaledario'
                  checked={inputs.isVerCaledario || false}
                  onChange={handleChange}
                  label='Añadir al calendario'
                  className='form-check-input-custom'
                  disabled={isViewMode}
                />
              </Form.Group>
            </div>
          </div>

          <div className='modal-form-container'>
            <div className='modal-form-field'>
              <Form.Group size='lg'>
                <Form.Label className='form__labels'>
                  Hospital / Centro (según Contacto seleccionado)
                  {/* <RequieredInputs /> */}
                </Form.Label>
                <Form.Control
                  as='select'
                  className='user-input form__input'
                  name='hospitales'
                  value={inputs.hospitales}
                  onChange={handleChange}
                  style={ inputs.id_Contacto ? {} : { opacity: 0.4 } }
                  disabled={true}
                  readOnly={true}
                >
                  <option style={{ opacity: 0.4 }} value=''>Seleccionar un Contacto para ver Hospital</option>
                  {sortedData.hospitals.map((hospital) => (
                    <option key={hospital.id_Hospital} value={hospital.nombre}>
                      {hospital.nombre}
                    </option>
                  ))}
                </Form.Control>
              </Form.Group>
            </div>

            <div className='modal-form-field'>
              <Form.Group size='md'>
                <Form.Label className='form__labels'>
                  Especialidad (según Contacto seleccionado)
                  {/* <RequieredInputs /> */}
                </Form.Label>
                <Form.Control
                  as='select'
                  className='user-input form__input'
                  name='especialidades'
                  value={inputs.especialidades || ''}
                  onChange={handleChange}
                  style={ inputs.id_Contacto ? {} : { opacity: 0.4 } }
                  disabled={true}
                  readOnly={true}
                >
                  <option style={{ opacity: 0.4 }} value=''>Seleccionar un Contacto para ver Especialidad</option>
                  {sortedData.specialties.map((specialty) => (
                    <option
                      key={specialty.id_Especialidad}
                      value={specialty.id_Especialidad}
                    >
                      {specialty.nombre}
                    </option>
                  ))}
                </Form.Control>
              </Form.Group>
            </div>

            {/* Evento relacionado */}
            <div className='modal-form-field'>
              <Form.Group size='lg'>
                <Form.Label className='form__labels'>
                  Evento relacionado
                </Form.Label>
                <Form.Control
                  as='select'
                  className='user-input form__input'
                  name='id_Evento'
                  value={inputs.id_Evento || ''}
                  onChange={handleEventoRelacionadoChange}
                  disabled={disableEventField || isViewMode}
                  style={
                    disableEventField || isViewMode
                      ? {
                          backgroundColor: '#f8f9fa',
                          color: '#6c757d',
                          cursor: 'not-allowed',
                          opacity: 0.65,
                        }
                      : {}
                  }
                >
                  <option value=''>Seleccionar Evento</option>
                  {eventos.map((evento) => (
                    <option key={evento.id_Evento} value={evento.id_Evento}>
                      {evento.nombre}
                    </option>
                  ))}
                </Form.Control>
              </Form.Group>
            </div>

            {/* Unidades de Negocio */}
            <div className='modal-form-field'>
              <Form.Group size='lg'>
                <Form.Label className='form__labels'>
                  Unidades de Negocio Asignadas (según Evento seleccionado)
                </Form.Label>
                {localBusinessUnits && localBusinessUnits.length > 0 ? (
                  <div
                    className='user-input form__input'
                    style={unitContainerStyle}
                  >
                    {localBusinessUnits.map((unitId) => {
                      const unit = sortedData.businessUnits.find(
                        (bu) => bu.id_NegocioUnidad === unitId,
                      )
                      return (
                        <div key={unitId} style={unitBadgeStyle}>
                          {unit ? unit.nombre : `Unidad ${unitId}`}
                        </div>
                      )
                    })}
                  </div>
                ) : (
                  <div
                    className='user-input form__input'
                    style={emptyStateStyle}
                    opacity={0.6}
                  >
                    Seleccione un Evento para ver las Unidades de Negocio asignadas
                  </div>
                )}
              </Form.Group>
            </div>

            {/* Descripción */}
            <div className='modal-form-field modal-form-field--textarea'>
              <Form.Group size='lg'>
                <Form.Label className='form__labels'>
                  Descripción <RequieredInputs />
                </Form.Label>
                <Form.Control
                  as='textarea'
                  rows={2}
                  className='user-input form__input'
                  name='descripcion'
                  value={inputs.descripcion || ''}
                  onChange={handleChange}
                  placeholder='Descripción del lead'
                  readOnly={isViewMode}
                />
              </Form.Group>
            </div>


          </div>

          <div className='modal-form-actions'>
            {!isViewMode && (
              <button
                onClick={handleSubmit}
                disabled={!validateForm()}
                className='btn save create'
                type='submit'
              >
                {textBtn}
              </button>
            )}
          </div>
        </Form>
      </ReactModal>
    </div>
  )
}

ReactModal.setAppElement('#root')
export default TasksModal
